export default {
    host: '/jeeboom/api/'
}